/**
 * Article entry.
 *
 * Assume these imports are loaded on article/single page types.
 */

// Import JavaScript
import UsageLogger from '@/js/utils/UsageLogger';

// Lightbox functionality
require('@/js/utils/fslightbox');

// Import SCSS
import './custom-properties.scss';
import '@/components/article/article';
import '@/components/article/article-authors';
import '@/components/article/article-connected-content';
import '@/components/article/article-content';
import '@/components/article/article-comments';
import '@/components/article/article-digital-library';
import '@/components/article/article-doi';
import '@/components/article/article-footnotes';
import '@/components/article/article-header';
import '@/components/article/article-issue';
import '@/components/article/article-references';
import '@/components/article/article-related';
import '@/components/cta/cta-join-the-discussion';
import '@/components/entry-content';
import '@/components/section-header';
import '@/components/the-latest';
import '@/components/article/article-key-insights';

// Instantiate components
// Components
import { ComponentManager } from 'js-component-framework';
import postListConfig from '@/components/post-list';
import accordionConfig from '@/components/accordion';
import bookmarkToggleConfig from '@/components/bookmark-toggle';
import printConfig from '@/components/print';
import shareConfig from '@/components/share';
import ctaMembershipConfig from '@/components/cta/cta-membership';
import articleTocConfig from '../../components/article/article-table-of-contents';
import authCommentFormConfig from '../../components/auth-comment-form';

// Log a page view.
const usageLogger = new UsageLogger();
usageLogger.logPageView();

// Create instance of the component manager using `cacm`
const manager = new ComponentManager('cacm');

// Initialize components
const components = [
  postListConfig,
  accordionConfig,
  bookmarkToggleConfig,
  printConfig,
  shareConfig,
  articleTocConfig,
  authCommentFormConfig,
  ctaMembershipConfig,
];

if ( document.readyState === 'complete' ) {
  manager.initComponents(components);
} else {
  document.addEventListener('DOMContentLoaded', () => {
    manager.initComponents(components);
  });
}

if (module.hot) {
  module.hot.accept();
  // This is required for HMR, otherwise you'll need to refresh
  // the page to see JS changes
  manager.initComponents(components);
}
